<!--Report>STD Balance Report页面-->
<template>
    <div class="mains">
        <div ref="refTopHeight">
            <a-row style="border: 1px solid #e8eaec;">
                <a-col>
                    <a-button size="small" class="mg5" @click="query">{{$t('job.Query')}}</a-button>
                    <a-button size="small" class="mg5" @click="reset">{{$t('job.Reset')}}</a-button>
                    <a-button size="small" class="mg5" @click="exportData">{{$t('generic.Export')}}</a-button>
                </a-col>
            </a-row>
            <a-form :form="formQuery" style="margin-top: 0px;margin-left: 10px;">
                <a-row>
                    <a-col span="3">
                        <a-form-item>
                            <b>{{$t('stdBalanceReport.department')}}:</b><br>
                            <a-input @pressEnter="query" size="small" v-decorator="['dudf01']"/>
                        </a-form-item>
                    </a-col>
                    <a-col span="3" offset="1">
                        <a-form-item>
                            <b>{{$t('stdBalanceReport.sku')}}:</b><br>
                            <a-input @pressEnter="query" size="small" v-decorator="['sku']"/>
                        </a-form-item>
                    </a-col>
                    <a-col span="3" offset="1">
                        <a-form-item>
                            <b>{{$t('stdBalanceReport.skuName')}}:</b><br>
                            <a-input @pressEnter="query" size="small" v-decorator="['skuDesc']"/>
                        </a-form-item>
                    </a-col>
                </a-row>
                <a-row>
                    <a-col span="3">
                        <a-form-item>
                            <b>{{$t('stdBalanceReport.material')}}:</b><br>
                            <a-input @pressEnter="query" size="small" v-decorator="['upc']"/>
                        </a-form-item>
                    </a-col>
                    <a-col span="3" offset="1">
                        <a-form-item>
                            <b>{{$t('stdBalanceReport.specification')}}:</b><br>
                            <a-input @pressEnter="query" size="small" v-decorator="['like']"/>
                        </a-form-item>
                    </a-col>
                </a-row>
            </a-form>
            <a-row>
                <a-col align="right" style="margin: 0 -7px 5px 0">
                    <!--分页-->
                    <a-pagination
                            :pageSizeOptions="pageSizeOptions"
                            :showTotal="total => $t('job.Total') + ` ${pagingTotal} `+$t('job.Records')"
                            size="small"
                            :total="pagingTotal"
                            v-model="currentVal"
                            :pageSize.sync="pagingSize"
                            @change="tableChangePage"
                            @showSizeChange="onShowSizeChange"
                            :showSizeChanger="showSizeChanger"
                            :showQuickJumper="showQuickJumper"
                    />
                </a-col>
            </a-row>
        </div>
        <a-row>
            <!--列表-->
            <vxe-table
                    border
                    resizable
                    stripe
                    column-key
                    highlight-hover-column
                    highlight-hover-row
                    show-header-overflow
                    show-overflow
                    :sort-config="{multiple: true, trigger: 'cell'}"
                    :edit-config="{trigger: 'click', mode: 'cell', showStatus: true}"
                    keep-source
                    :keyboard-config="{isArrow: true}"
                    align="center"
                    :data.sync="pagingGridList"
                    class="mytable-style "
                    :height="getLeftHeight"
                    ref="refLeftPagingGrid"
                    size="mini">
                <template v-slot:empty>
                    <a-empty></a-empty>
                </template>
              <vxe-table-column field="brand" :title="$t('stdBalanceReport.brand')"  width="130"  sortable  ></vxe-table-column>
              <vxe-table-column field="dudf01" :title="$t('stdBalanceReport.department')"  width="130"  sortable></vxe-table-column>
              <vxe-table-column field="sku" :title="$t('stdBalanceReport.sku')"  width="150"   sortable></vxe-table-column>
              <vxe-table-column field="skuDesc" :title="$t('stdBalanceReport.skuName')"   width="150" sortable></vxe-table-column>
              <vxe-table-column field="upc" :title="$t('stdBalanceReport.material')"  width="150"  sortable></vxe-table-column>
              <vxe-table-column field="info02" :title="$t('stdBalanceReport.specification')" width="100" sortable></vxe-table-column>
              <vxe-table-column field="info01" :title="$t('stdBalanceReport.units')"  width="100"  sortable></vxe-table-column>
              <vxe-table-column field="size" :title="$t('stdBalanceReport.size')"  width="150"  sortable></vxe-table-column>
              <vxe-table-column field="qty" :title="$t('stdBalanceReport.qty')"  width="100"   sortable></vxe-table-column>
              <vxe-table-column field="volume" :title="$t('stdBalanceReport.volume')"  width="100"  sortable></vxe-table-column>
              <vxe-table-column field="totalVolume" :title="$t('stdBalanceReport.totalVolume')"   width="100"  sortable></vxe-table-column>
              <vxe-table-column field="recDate" :title="$t('stdBalanceReport.inboundTime')" width="150" sortable></vxe-table-column>
              <vxe-table-column field="pickTime" :title="$t('stdBalanceReport.outboundTime')" width="150" sortable></vxe-table-column>
              <vxe-table-column field="period" :title="$t('stdBalanceReport.period')" width="200"  sortable > </vxe-table-column>
              <vxe-table-column field="remark" :title="$t('stdBalanceReport.remark')" width="300" sortable></vxe-table-column>
              <vxe-table-column field="location" :title="$t('stdBalanceReport.Location')"   width="150"  sortable></vxe-table-column>
              <vxe-table-column field="img" :title="$t('stdBalanceReport.prePicture')" show-header-overflow="ellipsis" show-overflow="ellipsis" width="300">
                <template slot-scope="scope">
                  <img v-if="scope.row.img != null && scope.row.img != ''" class="active" style="width: 20px;height: 20px;cursor:pointer;" :title="$t('publicLang.Preview')" src="../../../assets/img/preview.png" @click="preview(scope.row.img)">
                  <a  v-if="scope.row.img != null && scope.row.img != ''" @click="previewOpenUrl(baseUrl+scope.row.img)" target="_blank">{{baseUrl}}{{scope.row.img}}</a>
                </template>
              </vxe-table-column>
            </vxe-table>
        </a-row>
        <!--图片弹出框-->
        <a-modal v-model="isShow" :footer="null" :closable="false" width="80%">
            <img :src="imgUrl" style="border-radius: 5px;max-width: 100%;max-height: 600px;display: flex;margin: auto"/>
        </a-modal>
    </div>
</template>

<script>
    import ajax from "../../../api/ajax";
    import api from "../../../api/url";
    import cookie from "../../../api/cookie";
    import axios from "axios";

    export default{
        data(){
            return{
                pagingTotal: 0, // 总数
                pagingSize: 20, // 条数
                currentVal: 1, // 当前选中的页数
                showSizeChanger:true,//是否显示页码下拉框
                showQuickJumper:false,//是否显示快速跳转输入框
                pageSizeOptions:['10', '20', '30', '50','100','200','500','1000'],
                pagingGridList: [],//列表数据
                formQuery: this.$form.createForm(this, {}),
                leftTopHeight: 0,
                isShow:false,
                imgUrl:'',
                imgName:'',
                baseUrl:'',
            }
        },
        mounted() {
            this.leftTopHeight = this.$refs.refTopHeight.clientHeight;//左侧列表上部份div的高度
            this.baseUrl = window.location.protocol+"//"+window.location.host+"/#/previewImgFile?filePath=";
        },
        computed:{
            getLeftHeight(){
                return document.body.clientHeight - this.leftTopHeight - 100;//自适应查询列表的高度
            },
        },
        methods:{
            reset(){
                this.formQuery.resetFields();
            },
            query(){
                this.formQuery.validateFields((err, values) => {
                    if (err) {
                        this.$customMessage.warning(this.$t('publicLang.InputRequiredValue'), 2);
                        return;
                    }
                    if (values) {
                        let params = {//配置查询条件
                            dudf01 : values.dudf01,
                            sku : values.sku,
                            skuDesc : values.skuDesc,
                            upc : values.upc,
                            like : values.like,
                            currentVal : this.currentVal,
                            pagingSize : this.pagingSize,
                        }
                        ajax.post(api.GETSTDBALANCEREPORTLIST,params).then(res=>{
                            if(res.code == 200){
                                this.pagingGridList = res.data;//列表
                                this.pagingTotal = res.total;
                            }
                        })
                    }
                });
            },
            tableChangePage(current) {
                this.currentVal = current;
                this.query();
            },
            onShowSizeChange(current, pageSize) {//选择下拉框后触发事件
                this.currentVal = current;
                this.pagingSize = pageSize;
                this.query();
            },
            exportData(){
                this.formQuery.validateFields((err, values) => {
                    if(err){
                        this.$customMessage.warning(this.$t('publicLang.InputRequiredValue'), 2);
                        return;
                    }
                    if(values){
                        let ajaxurl = ajax.ajaxUrl();
                        let params = {//配置查询条件
                            dudf01 : values.dudf01,
                            sku : values.sku,
                            skuDesc : values.skuDesc,
                            upc : values.upc,
                            like : values.like,
                            currentVal : this.currentVal,
                            pagingSize : this.pagingSize,
                            baseUrl : this.baseUrl,
                        }
                        ajax.exportExcel(ajaxurl + api.EXPORTSTDBALANCELIST, params).then(data=>{
                            this.$store.commit("updataLoading", { pbLoading: false });
                            if (!data) {
                                return;
                            }
                            var blob = new Blob([data.data], {
                                type:
                                    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8"
                            });
                            var url = window.URL.createObjectURL(blob);
                            var aLink = document.createElement("a");
                            aLink.style.display = "none";
                            aLink.href = url;
                            aLink.setAttribute("download", "STD Balance Report.xlsx");
                            document.body.appendChild(aLink);
                            aLink.click();
                            document.body.removeChild(aLink); //下载完成移除元素
                            window.URL.revokeObjectURL(url); //释放掉blob对象
                        })
                    }
                });
            },
            preview(url){//预览图片
                if(url.length > 0){
                  // 请求图片流
                  axios.get(ajax.ajaxUrl()+api.PREVIEWIMGFILE, {
                    params: { filePath: encodeURIComponent(url) },
                    headers: {
                      Authorization: cookie.getBearerToken()
                    },
                    responseType: 'blob' // 重要：告诉axios期望接收二进制数据
                  }).then(response => {
                    // 从响应头获取内容类型，如果没有则默认使用 image/jpeg
                    const contentType = response.headers['content-type'] || 'image/jpeg';
                    // 处理blob数据
                    const urlBlob = window.URL.createObjectURL(new Blob([response.data],{ type: contentType }));
                    // 使用这个URL显示图片
                    this.imgUrl = urlBlob;
                    this.isShow = true;//显示图片
                    this.imgName = url.split('/').pop();
                  });
                }
            },
            previewOpenUrl(url){
              if(url.length > 0){
                window.open(url);
              }
            },
        }
    }
</script>

<style lang="less" scoped>
    .mains{
        height: 100%;
        width: 100%;
        background-color: white;
        float: left;
    }
</style>